import BaseController    from "controllers/backend/base"
import GeoCompletedAddress from "widgets/geoCompletedAddress";

class Controller extends BaseController {
  call() {
    super.call();
    bindAddressLocator.call(this)
  }
}

const bindAddressLocator = function() {

  const elems = this.root.find('input')

  for (let i=0; i<elems.length;i++) {
    new GeoCompletedAddress({
      root: elems[i],
      options: {
        types: ['address_1', 'address_2', 'suburb', 'state', 'postcode'],
        country: 'AU'
      }
    });
  }

};

export default Controller;
